import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_immersive")({
  component: ImmersiveLayout,
});

/**
 * Immersive layout for full-viewport pages (3D demos, etc.)
 * No padding, no sidebar - content takes full screen with HUD-style controls
 * Uses h-full to match parent's constrained height (root wraps outlet in flex-1 min-h-0)
 */
function ImmersiveLayout() {
  return (
    <div className="h-full w-full overflow-hidden">
      <Outlet />
    </div>
  );
}
